// src/belediye/redux/slices/authzSlice.js
//
// FAZ-12 — /me.permissions tüketimi. Kaynak: BelediyeApp bootstrap'ındaki
// MEVCUT /me çağrısı (ekstra istek yok) + birim değişiminde tazeleme.
// permission_ui şalteri KAPALIYKEN bu slice'ı kimse okumaz (uiOn=false).

import { createSlice } from "@reduxjs/toolkit";

import {
  EMPTY_AUTHZ,
  clearAuthzStorage,
  readAuthzFromStorage,
  writeAuthzToStorage,
} from "../../utils/authzStorage";

// Hydrate: sayfa yenilemede menü zıplamasın; /me gelince tazelenir.
const initialState = readAuthzFromStorage();

const authzSlice = createSlice({
  name: "authz",
  initialState,
  reducers: {
    // /me yanıtından (FAZ-07 MeSerializer alanları) doldur.
    authzSetFromMe(state, action) {
      const me = action.payload || {};
      state.permissions = Array.isArray(me.permissions) ? me.permissions : [];
      state.scope = me.scope || null;
      state.globalRole = me.global_role || null;
      state.enabledModules =
        me.enabled_modules && typeof me.enabled_modules === "object"
          ? me.enabled_modules
          : {};
      // FAZ-37: mesajlaşma özellik-flag'leri (mesajlasma.serbest/gorev/basvuru) —
      // enabledModules deseni birebir (yalnız açıkça false kapatır).
      state.enabledFeatures =
        me.enabled_features && typeof me.enabled_features === "object"
          ? me.enabled_features
          : {};
      state.activeUnit = me.active_unit || null;
      state.isSuperUser = me.is_superuser === true;
      state.uiProfile = me.ui_profile || null; // FAZ-17 — sunum profili
      state.status = "loaded";
      writeAuthzToStorage(state);
    },
    authzCleared() {
      clearAuthzStorage();
      return { ...EMPTY_AUTHZ };
    },
  },
});

export const { authzSetFromMe, authzCleared } = authzSlice.actions;

export const selectAuthz = (state) => state.authz || EMPTY_AUTHZ;
export const selectPermissions = (state) => selectAuthz(state).permissions;
export const selectEnabledModules = (state) => selectAuthz(state).enabledModules;
export const selectEnabledFeatures = (state) => selectAuthz(state).enabledFeatures;

export default authzSlice.reducer;
